import Vue from "vue";
import axios from "axios";

export default {
  saveClick: async ({ commit, rootState }, payload) => {
    const response = await axios.post(
      `${rootState.axios.API}clickTracking`,
      payload
    );
  },
  //loads click by the business id
  loadClickTally: async ({ commit, rootState }, payload) => {
    const response = await axios.get(
      `${rootState.axios.API}business/learnMoreTally`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    let tallyList = [];
    response.data.forEach((tally) => {
      tallyList.push({ ...tally });
      commit("setTallyData", tallyList);
    });
  },
};
